import React, { useState } from 'react';
import { Button, TextField, Grid, Select, FormControl, InputLabel, MenuItem } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { getDate } from '../../helpers/helperFunction.js'
const FilterPanelTrf = ({ onFilter, onReset, className, isTrfStatus }) => {
    const [searchValue, setSearchValue] = useState('');
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [statusFilter, setStatusFilter] = useState('');

    const handleSearchChange = (e) => {
        setSearchValue(e.target.value);
    };

    const handleFromDateChange = (date) => {
        setFromDate(date);
    };

    const handleToDateChange = (date) => {
        setToDate(date);
    };

    const handleStatusFilterChange = (e) => {
        setStatusFilter(e.target.value);
    };

    const handleFilter = () => {
        onFilter({
            search: searchValue,
            fromDate: getDate(fromDate),
            toDate: getDate(toDate),
            trfStatus: statusFilter,
        });
    };

    const handleReset = () => {
        setSearchValue('');
        setFromDate(null);
        setToDate(null);
        setStatusFilter('');
        onReset();
    };

    return (
        <div className={className}>
            <div className="card">
                <div className="card-body">
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} md={4}>
                            <TextField
                                label="Search"
                                variant="outlined"
                                value={searchValue}
                                onChange={handleSearchChange}
                                fullWidth
                            />
                        </Grid>
                        <><Grid item xs={12} md={2}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label="From Date"
                                    value={fromDate}
                                    onChange={handleFromDateChange}
                                    renderInput={(params) => <TextField {...params} variant="outlined" fullWidth />}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label="To Date"
                                    value={toDate}
                                    onChange={handleToDateChange}
                                    renderInput={(params) => <TextField {...params} variant="outlined" fullWidth />}
                                />
                            </LocalizationProvider>
                        </Grid>
                    </>
                     {isTrfStatus && 
                     <Grid item xs={12} md={3}>
                     <FormControl variant="outlined" fullWidth>
                         <InputLabel id="status-filter-label">Status</InputLabel>
                         <Select
                             labelId="status-filter-label"
                             value={statusFilter}
                             onChange={handleStatusFilterChange}
                             label="Status"
                         >
                             <MenuItem value="Shortlisted">Shortlisted</MenuItem>
                             <MenuItem value="Not Shortlisted">Not Shortlisted</MenuItem>
                             <MenuItem value="Verified">Verified</MenuItem>
                             <MenuItem value="Not Verified">Not Verified</MenuItem>
                             <MenuItem value="Rejected">Rejected</MenuItem>
                         </Select>
                     </FormControl>
                 </Grid>}
                    </Grid>
                    <Grid item xs={4} md={3} mt={2}>
                            <button className='btn btn-primary greeen-btn md_btn' onClick={handleFilter} fullWidth>
                                <span><i className="mdi mdi-plus-circle-outline"></i></span> Filter
                            </button>
                            <button className="btn btn-light grey-btn md_btn me-0" onClick={handleReset} >
                                <span><i className="bi bi-funnel"></i></span>Reset</button>
                        </Grid>
                        <Grid item xs={6} md={3} mt={2}>
                           
                        </Grid>
                </div>
            </div >
        </div >
    );
};

export default FilterPanelTrf;
